import React, { ReactNode } from 'react';
import {
  Box,
  BoxProps,
  Card,
  CardContent,
  CardContentProps,
  CardProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FILE_TYPE_LABEL, formatDateTime, formatFileSize } from '../model/formatters';
import type { CampaignKnowledgeBaseFile } from '../model/types';

type Props = {
  file: CampaignKnowledgeBaseFile;
  metadataDate: 'createdAt' | 'updatedAt';
  actions: ReactNode;
  children?: ReactNode;
  cardProps?: CardProps;
  contentProps?: CardContentProps;
  infoProps?: BoxProps;
  titleProps?: TypographyProps;
  metadataProps?: TypographyProps;
};

export const KnowledgeBaseFileRow: React.FC<Props> = ({
  file,
  metadataDate,
  actions,
  children,
  cardProps,
  contentProps,
  infoProps,
  titleProps,
  metadataProps,
}) => {
  const { t } = useTranslation();
  const dateLabelKey =
    metadataDate === 'createdAt'
      ? 'campaignPage.knowledgeBase.details.uploadDate'
      : 'campaignPage.knowledgeBase.details.updated';

  return (
    <Card variant="outlined" {...cardProps}>
      <CardContent {...contentProps}>
        <Box {...infoProps}>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            noWrap
            title={file.fileName}
            {...titleProps}>
            {file.fileName}
          </Typography>
          <Typography variant="body2" color="text.secondary" {...metadataProps}>
            {FILE_TYPE_LABEL} · {formatFileSize(file.size)} · {file.indexedChunksCount}{' '}
            {t('campaignPage.knowledgeBase.details.chunks').toLowerCase()} ·{' '}
            {t(dateLabelKey).toLowerCase()} {formatDateTime(file[metadataDate])}
          </Typography>
          {children}
        </Box>
        {actions}
      </CardContent>
    </Card>
  );
};
